import * as React from "react";
import {NavigationConfiguration} from "../../../../config/navigation-configuration";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";
import {withStore} from "../../../../core/stores/abstract-app-store";

export interface AktuellProps {
    store?: MapViewerStore; // this is injected by withStore
}

class AktuellBase extends React.Component<AktuellProps, any> {
    constructor(props: AktuellProps) {
        super(props);
    }
    componentDidMount(): void {
        const { store } = this.props;
        const breadcrumbs = new NavigationConfiguration();
        breadcrumbs.items = [
            { title: "Aktuell" }
        ];
        store?.appStore.setBreadcrumbs(breadcrumbs);
        store?.appStore.setPageTitle("Aktuell");
        store?.appStore.setAsideContent(null);
        store?.oStore.setShowMap(false);
    }
    render(): React.ReactElement | null {
        return(
            <div>
                <h3>20. Oktober 2025: Neues Gesetz im Kantonsrat einstimmig verabschiedet</h3>
                <p>
                    Das neue Gesetz zur Datendrehscheibe und Informationssystem Objektwesen (OWG) wurde im Kantonsrat einstimmig (mit einer Enthaltung) verabschiedet. Damit ist in diesem organisationsübergreifenden Projekt ein grosser Meilenstein erreicht worden. Jetzt sind die gesetzlichen Grundlagen für ein Informationssystem, das objektbezogene Daten aus verschiedenen Themenbereichen zentral bereitstellt, vorhanden.
                </p>
                <p>
                    Nun wird das definitive Informationssystem objekt.lu in Angriff genommen. Die Projektgruppe ist sich am Bilden und trifft sich im Januar zur Startsitzung. Im 2026 soll das Konzept für das Informationssystem erarbeitet werden sowie die Ausschreibung zur Umsetzung erfolgen. Diese ist schwerpunktmässig für 2027 geplant.
                </p>
            </div>
        );
    }
}

export const Aktuell = withStore(AktuellBase);
